// extracted by mini-css-extract-plugin
module.exports = {"footer":"CrhFooter_footer__Eqi_A"};